import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const siteSections = [
  {
    title: 'Company',
    links: [
      { name: 'Home', path: '/' },
      { name: 'About', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Banking',
    links: [
      { name: 'Personal Banking', path: '/personal-banking' },
      { name: 'Business Banking', path: '/business-banking' },
      { name: 'Loans & Mortgages', path: '/loans' },
      { name: 'Insurance', path: '/insurance-info' },
      { name: 'Online Banking', path: '/online-banking' },
    ],
  },
  {
    title: 'Account Access',
    links: [
      { name: 'Sign In', path: '/login' },
      { name: 'Open an Account', path: '/register' },
      { name: 'Forgot Password', path: '/forgot-password' },
    ],
  },
  {
    title: 'Legal & Resources',
    links: [
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Security Center', path: '/security' },
      { name: 'Accessibility', path: '/accessibility' },
      { name: 'Disclosures', path: '/disclosures' },
      { name: 'Site Map', path: '/sitemap' },
    ],
  },
];

const Sitemap = () => (
  <LegalPageLayout
    title="Site Map"
    subtitle="A quick index of public pages across Aurora Wealth Reserves."
  >
    <p>
      Use this site map to find key pages on aurorawealthreserves.com. Signed-in banking tools
      (dashboard, transfers, cards, and similar) appear after you <Link to="/login">sign in</Link>.
    </p>

    <div className="not-prose grid sm:grid-cols-2 gap-8 my-8">
      {siteSections.map((section) => (
        <div key={section.title}>
          <h2 className="font-display text-xl text-primary-900 mb-3">{section.title}</h2>
          <ul className="space-y-2">
            {section.links.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-heritage-700 hover:text-heritage-800 hover:underline"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </LegalPageLayout>
);

export default Sitemap;
